import { type Asset, type AssetType } from "@overmap-ai/common"
import { AssetService as OvermapAssetService, selectAssetsOfAssetType } from "@overmap-ai/core"
import { saveAs } from "file-saver"
import superagent from "superagent"

import type { RootState } from "../../store"
import type { AssetPdfExportOptions } from "../../typings/reports"
import type { AppSDK } from "../sdk"
import { getFilenameFromResponse, sendAuthenticated } from "../utils"

export class AssetService extends OvermapAssetService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL

	async bulkDeleteAllOfType(assetTypeId: AssetType["uuid"]): Promise<void> {
		const { store } = this.client

		const assets = selectAssetsOfAssetType(assetTypeId)(store.getState())

		return this.bulkDelete(assets.map(({ uuid }) => uuid))
	}

	async getAssetPdf(assetId: Asset["uuid"], options?: AssetPdfExportOptions) {
		const result = await sendAuthenticated(this.auth, () =>
			superagent
				.get(this.host + `/asset-export/pdf/${assetId}/`)
				.query(options ?? {})
				.responseType("blob"),
		)

		const filename = getFilenameFromResponse(result, "Asset.pdf")

		saveAs(result.body, filename)
	}

	async getAssetsPdf(assetTypeId: AssetType["uuid"], assetIds: Asset["uuid"][], options?: AssetPdfExportOptions) {
		const response = await sendAuthenticated(this.auth, () =>
			superagent
				.post(this.host + `/asset-export/pdf/bulk/${assetTypeId}/`)
				.send({ uuids: assetIds, options: options })
				.responseType("blob"),
		)

		const filename = getFilenameFromResponse(response, "Assets.pdf")

		saveAs(response.body, filename)
	}

	async getAssetsPdfReport(
		assetTypeId: AssetType["uuid"],
		assetIds: Asset["uuid"][],
		options?: AssetPdfExportOptions,
	) {
		await sendAuthenticated(this.auth, () =>
			superagent
				.post(this.host + `/asset-export/pdf/bulk/${assetTypeId}/`)
				.query({ report: true })
				.send({ uuids: assetIds, options: options }),
		)
	}
}
